import './_blurb.scss';
import Blurb from './Blurb';

/**
 * Blurb button wrapper that makes content clickable.
 * Use this to wrap the entire Blurb or specific parts.
 */
export default function BlurbCTA({
  primaryText = '',
  primaryHref = '',
  secondaryText = '',
  secondaryHref = '',
  className = ''
}) {
  const finalClassName = `Blurb__button ${className}`.trim();

  return (
    <div className={`Blurb__cta-button ${className}`}>
      {primaryHref && (
        <Blurb.Button href={primaryHref} priority="primary" size="m">
          {primaryText}
        </Blurb.Button>
      )}
      {secondaryHref && (
        <Blurb.Button href={secondaryHref} priority="secondary" size="m">
          {secondaryText}
        </Blurb.Button>
      )}
    </div>
  );
}
